import { 
  getToolboxTalkRuns,
  getToolboxTalkRun,
  runToolboxTalkNow,
  getToolboxTalkDocuments,
  getToolboxTalkDocument,
  createToolboxTalkDocument,
  updateToolboxTalkDocument,
  deleteToolboxTalkDocument,
  toggleToolboxTalkDocumentActive,
  getToolboxTalkStatistics
} from '../../../HttpRequests/toolboxTalks'
import { getSettings } from '../../../HttpRequests/settings'

export const fetchTBTSettings = () => {
  // Fetch TBT settings from the main settings system by filtering for "Tool Box Talks" group
  return getSettings({ 
    params: { 
      'filter[group]': 'Tool Box Talks',
      'page[size]': 100 
    } 
  })
}

export const fetchTBTRuns = (params = {}) => {
  return getToolboxTalkRuns({ params })
}

export const fetchRunDetails = (runId) => {
  return getToolboxTalkRun({ id: runId })
}

export const triggerManualTBTRun = () => {
  return runToolboxTalkNow()
}

// Document management services
export const fetchTBTDocuments = (params = {}) => {
  return getToolboxTalkDocuments({ params })
}

export const fetchTBTDocument = (id) => {
  return getToolboxTalkDocument({ id })
}

export const uploadTBTDocument = (formData) => {
  return createToolboxTalkDocument(formData)
}

export const updateTBTDocument = (id, formData) => {
  return updateToolboxTalkDocument({ id, formData })
}

export const deleteTBTDocument = (id) => {
  return deleteToolboxTalkDocument({ id })
}

export const toggleTBTDocumentActive = (id) => {
  return toggleToolboxTalkDocumentActive({ id })
}

export const fetchTBTStatistics = () => {
  return getToolboxTalkStatistics()
}
